export const STATION_STATUS_LABEL = {
  PUT_INTO: '已投运',
  NOT_PUT_INTO: '未投运',
  STOPPED: '暂停运营',
}

export const STATION_STATUS_VALUE = {
  PUT_INTO: 0,
  NOT_PUT_INTO: 1,
  STOPPED: 2,
}

export const statusSelectItems = [
  { title: '全部', value: '' },
  { title: STATION_STATUS_LABEL.PUT_INTO, value: STATION_STATUS_VALUE.PUT_INTO },
  { title: STATION_STATUS_LABEL.NOT_PUT_INTO, value: STATION_STATUS_VALUE.NOT_PUT_INTO },
  { title: STATION_STATUS_LABEL.STOPPED, value: STATION_STATUS_VALUE.STOPPED },
]

